import { type NamespacedStoreState, type UtilStoreState } from '@Types';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { useSelector } from 'react-redux';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

export const initState: UtilStoreState = {
	search: '',
	dataGridState: {},
	selectedUniqueIds: [],
	selectedUniqueStatus: '',
};

const UtilStoreSelector = createSelector(parseNamespace, state => state.util);

const SearchValueSelector = createSelector(
	UtilStoreSelector,
	state => state?.search || '',
);

export const SearchQuerySelector = createSelector(
	SearchValueSelector,
	(search: string) =>
		search.length ? `&search=${encodeURIComponent(search)}` : '',
);

export const DataGridSateSelector = createSelector(
	UtilStoreSelector,
	state => state.dataGridState,
);

export const selectSearchValue = () => useSelector(SearchValueSelector);

const selectorDataGridState = (key: string) => {
	return createSelector(DataGridSateSelector, state => {
		if (state) {
			return state[key];
		}
	});
};

export const selectDataGridState = (key: string) =>
	useSelector(selectorDataGridState(key));

const selectorUniqueSelectedIds = createSelector(
	UtilStoreSelector,
	state => state.selectedUniqueIds,
);

export const selectUniqueSelectedIds = () =>
	useSelector(selectorUniqueSelectedIds);

export const SelectedStatusSelector = createSelector(
	UtilStoreSelector,
	state => state.selectedUniqueStatus,
);

export const selectSelectedStatus = () => useSelector(SelectedStatusSelector);

export default selectSearchValue;
